import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var InboxCategoryTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(InboxCategoryTransformer, _BaseTransformer);
  var _super = _createSuper(InboxCategoryTransformer);
  function InboxCategoryTransformer() {
    _classCallCheck(this, InboxCategoryTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(InboxCategoryTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        recordId: data.record_id,
        sortOrder: data.sort_order,
        parentCategory: data.parent_category && data.parent_category.value ? data.parent_category.value : null,
        categoryName: data.category_name,
        active: data.active,
        slaLevel: data.sla_level,
        requestType: data.request_type,
        recordOwner: data.record_owner,
        createdOn: data.created_on,
        createdBy: data.created_by,
        lastModifiedOn: data.last_modified_on,
        lastModifiedBy: data.last_modified_by
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {
        record_id: data.recordId,
        sort_order: data.sortOrder,
        parent_category: data.parentCategory && data.parentCategory.value ? data.parentCategory.value : null,
        category_name: data.categoryName,
        request_type: data.requestType && data.requestType.value ? data.requestType.value : data.requestType,
        active: data.active,
        sla_level: data.slaLevel
      };
    }
  }]);
  return InboxCategoryTransformer;
}(BaseTransformer);